import axios from "axios";
import { useState } from "react";
import ReactDOM from "react-dom";

export const BASE_URL = "https://soucientprojectmanagementdevbk.athithishala.com/";

// export const BASE_URL = "https://soucientprojectmanagementtestbk.athithishala.com/";

// export const BASE_URL = "https://projectmanagementbk.soucient.com/"

// export const BASE_URL = "http://192.168.10.193:8000/"


const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } 
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isDialogOpen = false; 

const showDialog = async () => {
  if (isDialogOpen) {
    return new Promise((resolve) => resolve(false)); 
  }

  isDialogOpen = true;

  return new Promise((resolve) => {
    const SignOutPopup = () => {
      const [open, setOpen] = useState(true);

      const handleConfirm = () => {
        setOpen(false);
        isDialogOpen = false;
        resolve(true); 
        setTimeout(() => {
          window.location.href = "/sign-in";
        }, 0);
      };
      return (
        <></>
        // <SignOutDialog
        //   open={open}
        //   onConfirm={handleConfirm}
        // />
      );
    };

    const container = document.createElement("div");
    document.body.appendChild(container);
    const unmount = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    };
    ReactDOM.render(<SignOutPopup />, container);

    resolve.finally(() => {
      isDialogOpen = false;
      unmount();
    });
  });
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (originalRequest.url.includes("auth/login")) {
      return Promise.reject(error); 
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = sessionStorage.getItem("refreshToken");
      if (!refreshToken) {  
        console.error("No refresh token available. Redirecting to sign-in.");
        const confirm = await showDialog();
        if (confirm) {
          window.location.href = "/sign-in";
        }
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(`${BASE_URL}auth/refresh-token`, {
          refreshToken,
        });

        const newAccessToken = response?.data?.accessToken;

        if (newAccessToken) {
          sessionStorage.setItem("token", newAccessToken);

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return apiClient(originalRequest);
        } else {
          console.error("Failed to refresh token. Redirecting to sign-in.");
          const confirm = await showDialog();
          if (confirm) {
            window.location.href = "/sign-in";
          }
          return Promise.reject(error);
        }
      } catch (err) {
        console.error("Error refreshing token:", err);

        const confirm = await showDialog();
        if (confirm) {
          window.location.href = "/sign-in";
        }
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export const loginPostData = async (endpoint, data) => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const fetchData = async (endpoint) => {
  try {
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchDataById = async (endpoint) => {
  try {
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error fetching data by ID:", error);
    throw error;
  }
};

export const postData = async (endpoint, data) => {
  try {
    const headers = {};
    if (data instanceof FormData) {
      headers["Content-Type"] = undefined;
    }

    const response = await apiClient.post(endpoint, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const putData = async (endpoint, data) => {
  try {
    const headers = {};
    if (data instanceof FormData) {
      headers["Content-Type"] = undefined;
    }

    const response = await apiClient.put(endpoint, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Error updating data:", error);
    throw error;
  }
};

export const patchData = async (endpoint, data) => {
  try {
    const headers = {};
    if (data instanceof FormData) {
      headers["Content-Type"] = undefined;
    }

    const response = await apiClient.patch(endpoint, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Error patching data:", error);
    throw error;
  }
};

export const deleteData = async (endpoint) => {
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error deleting data:", error);
    throw error;
  }
};

export const downloadFileWithGet = async (endpoint, fileName) => {
  try {
    const response = await apiClient.get(endpoint, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error;
  }
};

export const downloadFileWithPost = async (endpoint, data, fileName) => {
  try {
    const response = await apiClient.post(endpoint, data, {
      responseType: "blob", // Important for file downloads
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file with POST:", error);
    throw error;
  }
};

//------ how to use -------

//Fetching Data(get):
// const fetchDataExample = async () => {
//   try {
//     const data = await fetchData('some-endpoint');
//     console.log('Fetched Data:', data);
//   } catch (error) {
//     console.error('Error fetching data:', error);
//   }
// };

//Fetching Data by ID(get by id):

// const fetchByIdExample = async (id) => {
//   try {
//     const data = await fetchDataById(`some-endpoint/${id}`);
//     console.log('Fetched Data by ID:', data);
//   } catch (error) {
//     console.error('Error fetching data by ID:', error);
//   }
// };

// Posting Data:
// const postDataExample = async () => {
//   const payload = { key: 'value' };
//   try {
//     const response = await postData('some-endpoint', payload);
//     console.log('Post Response:', response);
//   } catch (error) {
//     console.error('Error posting data:', error);
//   }
// };

// Updating Data:
// const putDataExample = async (id) => {
//   const payload = { key: 'updatedValue' };
//   try {
//     const response = await putData(`some-endpoint/${id}`, payload);
//     console.log('Update Response:', response);
//   } catch (error) {
//     console.error('Error updating data:', error);
//   }
// };

// Deleting Data:
// const deleteDataExample = async (id) => {
//   try {
//     const response = await deleteData(`some-endpoint/${id}`);
//     console.log('Delete Response:', response);
//   } catch (error) {
//     console.error('Error deleting data:', error);
//   }
// };

// const downloadPDF = async () => {
//   try {
//     await downloadFileWithGet("some-endpoint/pdf", "report.pdf");
//     console.log("PDF downloaded successfully.");
//   } catch (error) {
//     console.error("Error downloading PDF:", error);
//   }
// };

// const downloadExcel = async () => {
//   try {
//     await downloadFileWithGet("some-endpoint/excel", "data.xlsx");
//     console.log("Excel file downloaded successfully.");
//   } catch (error) {
//     console.error("Error downloading Excel file:", error);
//   }
// };

// const downloadPostFileExample = async () => {
//   const payload = { filter: "example", reportType: "pdf" };
//   try {
//     await downloadFileWithPost("download-report", payload, "report.pdf");
//     console.log("File downloaded successfully.");
//   } catch (error) {
//     console.error("Error downloading file:", error);
//   }
// };


//   <ListItemButton component="div" onClick={() => handleMenuClick("folder")}>
//           <ListItemIcon sx={{ color: "#000066", fontSize: "40px" }}>
//             <CreateNewFolderIcon />
//           </ListItemIcon>
//           <MaterialTypography variant="caption" color="text">
//             Add Folder
//           </MaterialTypography>
//         </ListItemButton>

// {currentFolder && (
//         <ListItemButton component="div" onClick={()=>handleMenuClick("file")}>
//        <ListItemIcon sx={{color:"grey",fontSize:"40px"}}>
//                <UploadFileIcon />
//        </ListItemIcon>
//        <MaterialTypography>
//         Upload files
//        </MaterialTypography>
// </ListItemButton>
// )}
//         {currentFolder && files[0]?.documents?.map((item, index)=>(

//           // <ListItemButton component="div" onClick={() => handleMenuClick("file")}>
//           <ListItemButton component="div" onClick={() => {
//             setDialogType("file");
//             setDialogOpen(true);
//             setSelectedFolder(currentFolder?.id);
//           }}>
//             <ListItemIcon sx={{ color: "#000066", fontSize: "40px" }}>
//               <UploadFileIcon />
//             </ListItemIcon>
//             <MaterialTypography variant="caption" color="text">
//               Upload files
//             </MaterialTypography>
//             <div key={index} style={{ marginBottom: "8px" }}>
//             <span>{item?.document_name}</span>
//           </div>
         
//       </ListItemButton>
//          ))}
